export const aboutData = {
    title: "Who I am",
    description1: `Hello! I'm Jasmine Zhang, an aspiring software engineer passionate about building reliable and meaningful software systems. My work spans mobile and web development, accessibility research, and creating intelligent applications powered by machine learning and ubiquitous computing.`,
    description2: "With a passion for innovation and a drive to push the boundaries of technology, I am dedicated to developing solutions that not only leverage the latest in tech but also create inclusive, user-centric experiences.",
    description3: "",
    image: 2
}